(function () {
  var STORAGE_KEY = 'a11yWidgetSettings';

  var defaults = {
    fontStep: 0,
    lineHeightStep: 0,
    bigCursor: false,
    tooltips: false,
    hideImages: false,
    readableFonts: false,
    dyslexia: false,
    pauseAnim: false,
    invertColors: false,
    brightnessStep: 0,
    contrastStep: 0,
    saturationStep: 0,
    colorFilter: 'none',
    readingGuide: false,
    readingMask: false,
    highlightLinks: false,
    underlineLinks: false
  };

  function readStoredSettings() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  var settings = Object.assign({}, defaults, readStoredSettings());
  var wrap, root = document.documentElement;
  var speaking = false;
  var optionsView, statementView, backBtn, headTitle;

  var STATEMENT_HTML =
    '<h1>Accessibility Statement</h1>' +
    '<p><strong>Last updated: July 21, 2026</strong></p>' +
    '<h2>Our Commitment to Accessibility</h2>' +
    '<p>We are committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone, and applying relevant accessibility standards to help users with a wide range of disabilities use our site effectively.</p>' +
    '<h2>Compliance Status</h2>' +
    '<p>Our website strives to conform to the <a href="https://www.w3.org/WAI/WCAG21/quickref/" target="_blank" rel="noopener">Web Content Accessibility Guidelines (WCAG) 2.1</a> Level AA. These guidelines explain how to make web content more accessible to people with a wide range of disabilities. We acknowledge that some aspects of our site may not yet achieve full conformance, and we are actively working to address these areas.</p>' +
    '<h2>Accessibility Features Available</h2>' +
    '<p>We\'ve built the following tools directly into this site, available from the icon in the corner of every page:</p>' +
    '<h3>Visual Adjustments</h3>' +
    '<ul>' +
      '<li><strong>Bigger Text</strong>: Increase text size for better readability</li>' +
      '<li><strong>Bigger Cursor</strong>: Enhanced cursor visibility for easier navigation</li>' +
      '<li><strong>Color Adjustments</strong>: Invert colors, adjust brightness, contrast, and saturation</li>' +
      '<li><strong>Color-Blindness Filters</strong>: Red/green, blue/yellow, green/red, and grayscale modes</li>' +
      '<li><strong>Hide Images</strong>: Reduce visual distractions for easier reading</li>' +
    '</ul>' +
    '<h3>Reading and Navigation Aids</h3>' +
    '<ul>' +
      '<li><strong>Reading Line</strong>: Adds a guide to help follow text</li>' +
      '<li><strong>Reading Mask</strong>: Places a mask over the page to isolate lines and enhance focus</li>' +
      '<li><strong>Readable Fonts</strong>: Converts to a highly legible typeface for better comprehension</li>' +
      '<li><strong>Highlight Links</strong>: Makes links more prominent for easier navigation</li>' +
      '<li><strong>Dyslexic Font</strong>: Special typography for users with dyslexia</li>' +
      '<li><strong>Page Structure</strong>: Jump directly between headings without a mouse</li>' +
    '</ul>' +
    '<h3>Assistive Technologies</h3>' +
    '<ul>' +
      '<li><strong>Keyboard Navigation</strong>: Every control in this panel can be reached and operated with Tab, Shift+Tab, and Enter</li>' +
      '<li><strong>Tooltips</strong>: Descriptive text for icons and links on hover</li>' +
      '<li><strong>Read Page Aloud</strong>: Text-to-speech functionality using your browser\'s built-in voice</li>' +
      '<li><strong>Stop Animations</strong>: Pause motion content for users with vestibular disorders</li>' +
    '</ul>' +
    '<p>These tools run entirely in your browser. We don\'t send page content to a third party to provide them.</p>' +
    '<h2>Limitations and Feedback</h2>' +
    '<p>Despite our best efforts to ensure accessibility, there may be some limitations. Content provided by third parties, user-generated content, or certain legacy pages may not be fully accessible. We are continuously working to improve our website\'s accessibility.</p>' +
    '<p>We welcome your feedback on the accessibility of our website. If you encounter any barriers or have suggestions for improvement, please contact us. We are committed to addressing these issues promptly.</p>' +
    '<h2>Legal Disclaimer</h2>' +
    '<p>While we strive to adhere to WCAG 2.1 Level AA standards and provide accessible content, we cannot guarantee that our website will be accessible to all users under all circumstances. This website is provided \'as is\' without any representations or warranties, express or implied.</p>' +
    '<p>In no event shall we be liable for any damages arising from or related to:</p>' +
    '<ul>' +
      '<li>Inability to access or use the website</li>' +
      '<li>Any alleged non-compliance with accessibility laws or regulations</li>' +
      '<li>Any disruption or errors in the functionality of accessibility features</li>' +
    '</ul>' +
    '<p>By using this website, you agree to hold us harmless from any claims related to website accessibility issues. We are committed to addressing accessibility barriers in good faith but cannot guarantee immediate resolution in all cases.</p>' +
    '<h2>Contact Us</h2>' +
    '<p>If you have any questions about our accessibility efforts or encounter any barriers while using our website, please contact us at <a href="mailto:support@simpleshapes.com">support@simpleshapes.com</a>.</p>' +
    '<hr><p class="a11y-fine-print">This statement was prepared in good faith and has not been reviewed by legal counsel. Simple Shapes has not had this site independently audited against WCAG or ADA standards.</p>';

  function save() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(settings)); } catch (e) { /* storage unavailable (e.g. sandboxed preview) */ }
  }

  function injectColorMatrices() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'a11y-icon');
    svg.style.position = 'absolute';
    svg.style.width = '0';
    svg.style.height = '0';
    svg.innerHTML =
      '<defs>' +
        '<filter id="a11y-protanopia"><feColorMatrix type="matrix" values="0.567,0.433,0,0,0 0.558,0.442,0,0,0 0,0.242,0.758,0,0 0,0,0,1,0"/></filter>' +
        '<filter id="a11y-deuteranopia"><feColorMatrix type="matrix" values="0.625,0.375,0,0,0 0.7,0.3,0,0,0 0,0.3,0.7,0,0 0,0,0,1,0"/></filter>' +
        '<filter id="a11y-tritanopia"><feColorMatrix type="matrix" values="0.95,0.05,0,0,0 0,0.433,0.567,0,0 0,0.475,0.525,0,0 0,0,0,1,0"/></filter>' +
      '</defs>';
    document.body.appendChild(svg);
  }

  var ICON = {
    biggerText: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="6.5"/><line x1="15" y1="15" x2="20.5" y2="20.5"/><line x1="7" y1="10" x2="13" y2="10"/><line x1="10" y1="7" x2="10" y2="13"/></svg>',
    cursor: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 3l6 16 2.5-6.5L20 10z"/></svg>',
    tooltip: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h16v10H9l-4 4V5z"/><line x1="8" y1="9" x2="16" y2="9"/></svg>',
    lineHeight: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="9" y1="5" x2="20" y2="5"/><line x1="9" y1="12" x2="20" y2="12"/><line x1="9" y1="19" x2="20" y2="19"/><path d="M4 3v18M2 5l2-2 2 2M2 17l2 2 2-2"/></svg>',
    hideImages: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="14" rx="1.5"/><circle cx="8" cy="9" r="1.6"/><path d="M4 15l5-4 4 3 3-2 4 4"/><line x1="2" y1="21" x2="22" y2="1" stroke="#c0392b"/></svg>',
    pause: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>',
    invert: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 000 18z" fill="currentColor" stroke="none"/></svg>',
    brightness: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="4.5"/><path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1"/></svg>',
    contrast: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 000 18z" fill="currentColor" stroke="none"/></svg>',
    saturation: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linejoin="round"><path d="M12 3c3 4 6 7.4 6 11a6 6 0 01-12 0c0-3.6 3-7 6-11z"/></svg>',
    readingGuide: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round"><rect x="3" y="10" width="18" height="4" rx="1"/><line x1="3" y1="5" x2="21" y2="5" opacity=".4"/><line x1="3" y1="19" x2="21" y2="19" opacity=".4"/></svg>',
    link: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round"><path d="M9.5 14.5l5-5M8 16l-2 2a3.5 3.5 0 01-5-5l3-3a3.5 3.5 0 015 0M16 8l2-2a3.5 3.5 0 015 5l-3 3a3.5 3.5 0 01-5 0"/></svg>',
    speaker: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M17 9a4 4 0 010 6M19.5 6.5a8 8 0 010 11"/></svg>',
    mask: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round"><rect x="3" y="4" width="18" height="16" rx="1.5"/><rect x="3" y="10" width="18" height="4" fill="currentColor" stroke="none" opacity=".85"/></svg>',
    structure: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="15" y2="12"/><line x1="4" y1="18" x2="11" y2="18"/></svg>',
    close: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>',
    reset: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4v6h6M20 20v-6h-6"/><path d="M5.5 15a8 8 0 0013.5 3.5M18.5 9A8 8 0 005 5.5"/></svg>',
    a11y: '<svg class="a11y-icon" viewBox="0 0 24 24" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="7.5" r="1.6" fill="currentColor" stroke="none"/><path d="M6 10.5c2 .8 4 1.2 6 1.2s4-.4 6-1.2M12 11.7V19M9 19l1.6-5.5M15 19l-1.6-5.5"/></svg>'
  };

  function tile(opts) {
    var attrs = 'class="a11y-tile" role="button" tabindex="0" aria-label="' + opts.label + '"';
    if (opts.kind === 'toggle') attrs += ' data-toggle="' + opts.key + '"';
    if (opts.kind === 'step') attrs += ' data-step="' + opts.key + '" data-max="' + opts.max + '"';
    var iconHtml = opts.glyph
      ? '<span class="a11y-glyph">' + opts.glyph + '</span>'
      : ICON[opts.icon];
    var dots = '';
    if (opts.kind === 'step') {
      dots = '<div class="a11y-dots">' +
        Array.from({ length: opts.max }).map(function () { return '<span></span>'; }).join('') +
        '</div>';
    }
    return '<div ' + attrs + '>' + iconHtml + '<span class="a11y-label">' + opts.label + '</span>' + dots + '</div>';
  }

  function buildPanel() {
    var panel = document.createElement('div');
    panel.id = 'a11y-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Accessibility options');
    panel.hidden = true;

    panel.innerHTML =
      '<div class="a11y-head">' +
        '<button class="a11y-back" data-action="back" aria-label="Back" hidden>&larr; Back</button>' +
        '<span class="a11y-head-title">Accessibility Options</span>' +
        '<button data-action="close" aria-label="Close">' + ICON.close + '</button>' +
      '</div>' +
      '<div class="a11y-body">' +
      '<div id="a11y-view-options">' +
        '<div class="a11y-top-link"><a href="#" data-action="statement">Accessibility Statement</a></div>' +
        '<p class="a11y-feedback-note">If you find anything on our site that isn\'t accessible to you, please let us know at <a href="mailto:support@simpleshapes.com">support@simpleshapes.com</a>. We take these reports seriously and prioritize fixing them.</p>' +
        '<h3>Content</h3>' +
        '<div class="a11y-grid">' +
          tile({ key: 'fontStep', icon: 'biggerText', label: 'Bigger Text', kind: 'step', max: 3 }) +
          tile({ key: 'bigCursor', icon: 'cursor', label: 'Bigger Cursor', kind: 'toggle' }) +
          tile({ key: 'tooltips', icon: 'tooltip', label: 'Tooltips', kind: 'toggle' }) +
          tile({ key: 'lineHeightStep', icon: 'lineHeight', label: 'Line Height', kind: 'step', max: 3 }) +
          tile({ key: 'hideImages', icon: 'hideImages', label: 'Hide Images', kind: 'toggle' }) +
          tile({ key: 'readableFonts', glyph: 'Aa', label: 'Readable Fonts', kind: 'toggle' }) +
          tile({ key: 'dyslexia', glyph: 'Aa', label: 'Dyslexic Font', kind: 'toggle' }) +
          tile({ key: 'pauseAnim', icon: 'pause', label: 'Stop Animations', kind: 'toggle' }) +
        '</div>' +

        '<h3>Colors</h3>' +
        '<div class="a11y-grid">' +
          tile({ key: 'invertColors', icon: 'invert', label: 'Invert Colors', kind: 'toggle' }) +
          tile({ key: 'brightnessStep', icon: 'brightness', label: 'Brightness', kind: 'step', max: 3 }) +
          tile({ key: 'contrastStep', icon: 'contrast', label: 'Contrast', kind: 'step', max: 3 }) +
          tile({ key: 'saturationStep', icon: 'saturation', label: 'Saturation', kind: 'step', max: 3 }) +
        '</div>' +
        '<div class="a11y-filters">' +
          '<div class="a11y-filters-title">Color Filters</div>' +
          '<div class="a11y-filter-grid">' +
            '<div class="a11y-filter-row"><button class="a11y-filter-btn" data-filter="grayscale"><span class="a11y-swatch" style="background:#9a9a9a"></span>Grayscale</button></div>' +
            '<div class="a11y-filter-row"><button class="a11y-filter-btn" data-filter="protanopia"><span class="a11y-swatch" style="background:conic-gradient(#e04b4b 0 50%, #4bb35c 50% 100%)"></span>Red / Green</button></div>' +
            '<div class="a11y-filter-row"><button class="a11y-filter-btn" data-filter="tritanopia"><span class="a11y-swatch" style="background:conic-gradient(#3d6bd8 0 50%, #e0c93d 50% 100%)"></span>Blue / Yellow</button></div>' +
            '<div class="a11y-filter-row"><button class="a11y-filter-btn" data-filter="deuteranopia"><span class="a11y-swatch" style="background:conic-gradient(#4bb35c 0 50%, #e04b4b 50% 100%)"></span>Green / Red</button></div>' +
          '</div>' +
        '</div>' +

        '<h3>Navigation</h3>' +
        '<div class="a11y-grid">' +
          tile({ key: 'readingGuide', icon: 'readingGuide', label: 'Reading Line', kind: 'toggle' }) +
          tile({ key: 'highlightLinks', icon: 'link', label: 'Highlight Links', kind: 'toggle' }) +
          tile({ key: 'readPage', icon: 'speaker', label: 'Read Page', kind: 'toggle' }) +
          tile({ key: 'readingMask', icon: 'mask', label: 'Reading Mask', kind: 'toggle' }) +
          tile({ key: 'pageStructure', icon: 'structure', label: 'Page Structure', kind: 'toggle' }) +
        '</div>' +

        '<button id="a11y-reset">' + ICON.reset + ' Reset Settings</button>' +
      '</div>' +
      '<div id="a11y-view-statement" hidden>' + STATEMENT_HTML + '</div>' +
      '</div>';

    document.body.appendChild(panel);
    optionsView = panel.querySelector('#a11y-view-options');
    statementView = panel.querySelector('#a11y-view-statement');
    backBtn = panel.querySelector('.a11y-back');
    headTitle = panel.querySelector('.a11y-head-title');
    return panel;
  }

  function showView(view) {
    optionsView.hidden = view !== 'options';
    statementView.hidden = view !== 'statement';
    backBtn.hidden = view !== 'statement';
    headTitle.textContent = view === 'statement' ? 'Accessibility Statement' : 'Accessibility Options';
  }

  function buildOverlays() {
    var guide = document.createElement('div');
    guide.id = 'a11y-reading-guide';
    document.body.appendChild(guide);

    var maskTop = document.createElement('div');
    maskTop.id = 'a11y-reading-mask-top';
    var maskBottom = document.createElement('div');
    maskBottom.id = 'a11y-reading-mask-bottom';
    document.body.appendChild(maskTop);
    document.body.appendChild(maskBottom);

    document.addEventListener('mousemove', function (e) {
      if (settings.readingGuide) guide.style.top = (e.clientY - 16) + 'px';
      if (settings.readingMask) {
        var bandHalf = 60;
        maskTop.style.height = Math.max(0, e.clientY - bandHalf) + 'px';
        maskBottom.style.height = Math.max(0, window.innerHeight - e.clientY - bandHalf) + 'px';
      }
    });

    var bubble = document.createElement('div');
    bubble.id = 'a11y-tooltip-bubble';
    bubble.hidden = true;
    document.body.appendChild(bubble);

    function showTooltip(e) {
      if (!settings.tooltips) return;
      var el = e.target.closest('[title],[aria-label],img[alt]');
      if (!el || el.closest('#a11y-panel, #a11y-toggle, #a11y-structure-panel')) { bubble.hidden = true; return; }
      var text = el.getAttribute('title') || el.getAttribute('aria-label') || el.getAttribute('alt');
      if (!text) { bubble.hidden = true; return; }
      bubble.textContent = text;
      bubble.hidden = false;
      bubble.style.left = Math.min(e.clientX + 12, window.innerWidth - 260) + 'px';
      bubble.style.top = (e.clientY + 16) + 'px';
    }
    document.addEventListener('mousemove', showTooltip);
    document.addEventListener('mouseleave', function () { bubble.hidden = true; });

    var structurePanel = document.createElement('div');
    structurePanel.id = 'a11y-structure-panel';
    structurePanel.hidden = true;
    structurePanel.setAttribute('role', 'dialog');
    structurePanel.setAttribute('aria-label', 'Page structure');
    document.body.appendChild(structurePanel);

    return { guide: guide, maskTop: maskTop, maskBottom: maskBottom, bubble: bubble, structurePanel: structurePanel };
  }

  function buildToggleButton(panel) {
    var btn = document.createElement('button');
    btn.id = 'a11y-toggle';
    btn.setAttribute('aria-label', 'Accessibility options');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = ICON.a11y;

    function open() { panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); showView('options'); }
    function close() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }

    btn.addEventListener('click', function () { panel.hidden ? open() : close(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { close(); btn.focus(); }
    });

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-action="close"]')) close();
    });

    document.body.appendChild(btn);
    return btn;
  }

  function buildFilterString() {
    var parts = [];
    if (settings.brightnessStep) parts.push('brightness(' + (100 + settings.brightnessStep * 15) + '%)');
    if (settings.contrastStep) parts.push('contrast(' + (100 + settings.contrastStep * 20) + '%)');
    if (settings.saturationStep) parts.push('saturate(' + (100 + settings.saturationStep * 40) + '%)');
    if (settings.invertColors) parts.push('invert(1) hue-rotate(180deg)');
    if (settings.colorFilter !== 'none') parts.push('url(#a11y-' + settings.colorFilter + ')');
    return parts.join(' ');
  }

  function applyAll() {
    wrap.style.zoom = (100 + settings.fontStep * 15) + '%';
    wrap.setAttribute('data-a11y-line-height', settings.lineHeightStep || '');
    wrap.style.filter = buildFilterString();

    var toggles = ['bigCursor', 'hideImages', 'readableFonts', 'dyslexia', 'pauseAnim', 'highlightLinks', 'underlineLinks'];
    var classMap = { bigCursor: 'a11y-big-cursor', hideImages: 'a11y-hide-images', readableFonts: 'a11y-readable-font', dyslexia: 'a11y-dyslexia-font', pauseAnim: 'a11y-pause-anim', highlightLinks: 'a11y-highlight-links', underlineLinks: 'a11y-underline-links' };
    toggles.forEach(function (key) { wrap.classList.toggle(classMap[key], !!settings[key]); });

    root.classList.toggle('a11y-reading-guide-on', !!settings.readingGuide);
    root.classList.toggle('a11y-reading-mask-on', !!settings.readingMask);

    if (settings.dyslexia && !document.getElementById('a11y-dyslexic-font-link')) {
      var link = document.createElement('link');
      link.id = 'a11y-dyslexic-font-link';
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/open-dyslexic@1.0.3/open-dyslexic-regular.css';
      document.head.appendChild(link);
    }
  }

  function syncTileStates(panel) {
    panel.querySelectorAll('[data-toggle]').forEach(function (t) {
      t.setAttribute('aria-pressed', !!settings[t.dataset.toggle]);
    });
    panel.querySelectorAll('[data-step]').forEach(function (t) {
      var val = settings[t.dataset.step] || 0;
      var max = Number(t.dataset.max);
      t.setAttribute('aria-pressed', val > 0);
      var dots = t.querySelectorAll('.a11y-dots span');
      dots.forEach(function (d, i) { d.classList.toggle('on', i < val); });
    });
    panel.querySelectorAll('[data-filter]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.filter === settings.colorFilter);
    });
  }

  function toggleReadPage(panel) {
    if (speaking) {
      window.speechSynthesis.cancel();
      speaking = false;
    } else if ('speechSynthesis' in window) {
      var text = wrap.innerText || wrap.textContent || '';
      var utter = new SpeechSynthesisUtterance(text.slice(0, 6000));
      utter.onend = function () {
        speaking = false;
        var btn = panel.querySelector('[data-toggle="readPage"]');
        if (btn) btn.setAttribute('aria-pressed', 'false');
      };
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(utter);
      speaking = true;
    } else {
      alert('Text-to-speech is not supported in this browser.');
    }
    var btn = panel.querySelector('[data-toggle="readPage"]');
    if (btn) btn.setAttribute('aria-pressed', String(speaking));
  }

  function togglePageStructure(overlays, panel) {
    var sp = overlays.structurePanel;
    if (!sp.hidden) { sp.hidden = true; syncStructureTile(panel, false); return; }

    var headings = Array.from(wrap.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    if (!headings.length) {
      sp.innerHTML = '<h3>Page Structure</h3><p style="font-size:13px;color:#666;">No headings found on this page.</p>';
    } else {
      var items = headings.map(function (h, i) {
        if (!h.id) h.id = 'a11y-heading-' + i;
        var level = h.tagName.toLowerCase();
        return '<li class="a11y-' + level + '"><a href="#' + h.id + '" data-target="' + h.id + '">' + h.textContent.trim().slice(0, 80) + '</a></li>';
      }).join('');
      sp.innerHTML = '<h3>Page Structure</h3><ul>' + items + '</ul>';
    }
    sp.hidden = false;
    syncStructureTile(panel, true);

    sp.onclick = function (e) {
      var a = e.target.closest('a[data-target]');
      if (!a) return;
      e.preventDefault();
      var el = document.getElementById(a.dataset.target);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.setAttribute('tabindex', '-1');
        el.focus();
      }
      sp.hidden = true;
      syncStructureTile(panel, false);
    };
  }
  function syncStructureTile(panel, on) {
    var btn = panel.querySelector('[data-toggle="pageStructure"]');
    if (btn) btn.setAttribute('aria-pressed', String(on));
  }

  function wrapPageContent() {
    wrap = document.createElement('div');
    wrap.id = 'a11y-page-wrap';
    while (document.body.firstChild) wrap.appendChild(document.body.firstChild);
    document.body.appendChild(wrap);
  }

  // ---------------------------------------------------------------
  // Third-party app DOM patches — some installed apps (the Wizart
  // visualizer, Klaviyo's Slick-based product recommendation carousel,
  // Judge.me's review carousel) inject their own markup at runtime with
  // real accessibility bugs we can't fix at the source. Patched here
  // instead, watched via MutationObserver since that markup can
  // render/re-render at any time.
  // ---------------------------------------------------------------

  // aria-hidden="true" in markup doesn't always mean an element is
  // actually invisible — e.g. SmartTabs Product Tabs marks inactive tab
  // panels aria-hidden="true" but switches panels by toggling a class or
  // inline style, without ever updating that attribute back to "false"
  // once a panel becomes the active/visible one. Trusting the attribute
  // alone previously caused real, visible content (like PDF links in an
  // "Instructions" tab) to get stuck permanently inert. Check actual
  // rendered visibility instead of just the attribute value.
  function isVisuallyHidden(el) {
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return true;
    return el.offsetWidth === 0 && el.offsetHeight === 0 && el.getClientRects().length === 0;
  }

  function fixThirdPartyA11yIssues() {
    document.querySelectorAll('meta[name="viewport"]').forEach(function (meta) {
      var content = meta.getAttribute('content') || '';
      if (/user-scalable\s*=\s*no/i.test(content) || /maximum-scale/i.test(content)) {
        meta.setAttribute('content', 'width=device-width, initial-scale=1.0');
      }
    });

    document.querySelectorAll('.slick-track').forEach(function (track) {
      if (!track.getAttribute('aria-label')) {
        track.setAttribute('aria-label', 'Product carousel');
      }
      // role="listbox" requires role="option" children, but slides can't
      // carry role="option" (see below — they wrap real interactive links,
      // which a widget role isn't allowed to contain). Slick's
      // listbox/option pairing never accurately described this carousel to
      // begin with — it's not a real selectable list with managed
      // aria-activedescendant — so drop the listbox role entirely rather
      // than fight the two requirements against each other.
      if (track.getAttribute('role') === 'listbox') {
        track.removeAttribute('role');
      }
    });

    // Judge.me keeps off-screen/clone review slides in the DOM inside
    // aria-hidden="true" containers — aria-hidden alone doesn't stop a
    // keyboard user from tabbing into that hidden content, so anything
    // focusable inside must also get tabindex="-1". tabindex="-1" alone
    // still isn't enough for axe's stricter check (assistive tech can
    // still reach a tabindex="-1" element via browse-mode or a
    // programmatic .focus() call), so also mark the whole aria-hidden
    // subtree inert — the modern, browser-native way to fully remove a
    // subtree from focus and the accessibility tree.
    // Only do this for content that is genuinely invisible right now —
    // some apps (SmartTabs) leave aria-hidden="true" stamped on a panel
    // even after visually showing it, and inert-ing visible content would
    // make its real links permanently unclickable.
    document.querySelectorAll('[aria-hidden="true"]').forEach(function (hidden) {
      if (!isVisuallyHidden(hidden)) return;
      hidden.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach(function (el) {
        if (el.tabIndex !== -1) el.setAttribute('tabindex', '-1');
      });
      if (!hidden.hasAttribute('inert')) {
        hidden.setAttribute('inert', '');
      }
    });

    // Slick flips aria-hidden back to "false" on whichever slide rotates
    // into the active position, which is the normal case this undoes.
    // Some apps (SmartTabs) never flip the attribute at all when a panel
    // becomes visible, so also fall back to checking actual visibility —
    // if the element is genuinely on screen, it must not stay inert
    // regardless of what its aria-hidden attribute claims.
    document.querySelectorAll('[inert]').forEach(function (el) {
      if (el.getAttribute('aria-hidden') !== 'true' || !isVisuallyHidden(el)) {
        el.removeAttribute('inert');
        el.querySelectorAll('a[href][tabindex="-1"], button[tabindex="-1"], input[tabindex="-1"], select[tabindex="-1"], textarea[tabindex="-1"]').forEach(function (child) {
          child.removeAttribute('tabindex');
        });
      }
    });

    // Judge.me's review-photo thumbnails ("jdgm-rev__pic-link") render a
    // loading-state placeholder inside the anchor while their image loads,
    // which gives the link non-empty textContent — that would make the
    // generic check below skip it, wrongly treating the placeholder as if
    // it were already a real accessible name. Handle this class on its own,
    // unconditionally (labeling it plainly describes what the link does —
    // open a customer's review photo — regardless of loading state).
    document.querySelectorAll('a.jdgm-rev__pic-link').forEach(function (link) {
      if (!link.getAttribute('aria-label') && !link.getAttribute('aria-labelledby')) {
        link.setAttribute('aria-label', 'View review photo');
      }
    });

    // Links to a product or collection page always have a real, derivable
    // name from their URL slug, so label them unconditionally (skipping
    // only ones that already carry a real aria-label). Several different
    // patterns here — hero-slideshow slides with a caption overlaid as a
    // sibling rather than inner text, above-the-fold product cards with an
    // impression-tracking wrapper, Klaviyo's recommendation carousel —
    // kept showing up unlabeled across many rounds despite matching this
    // slug regex, because a "does it already have text?" gate kept
    // short-circuiting past the label logic for reasons that varied by
    // widget. Deriving the label unconditionally for any products/
    // collections link sidesteps that whole class of bug at once.
    document.querySelectorAll('a[href]').forEach(function (link) {
      if (link.getAttribute('aria-label') || link.getAttribute('aria-labelledby')) return;
      var match = (link.getAttribute('href') || '').match(/\/(?:products|collections)\/([^/?#]+)/);
      if (match) {
        var name = match[1].replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        link.setAttribute('aria-label', name);
      }
    });

    // Any other <a> with genuinely no text, no label, and no img alt (not
    // a product/collection link, so nothing to derive a name from) is a
    // silent stop for screen reader users — remove it from the
    // accessibility tree entirely rather than leave it there unnamed.
    document.querySelectorAll('a[href]').forEach(function (link) {
      var text = link.textContent.trim();
      var hasLabel = link.getAttribute('aria-label') || link.getAttribute('aria-labelledby');
      var hasImgAlt = link.querySelector('img[alt]:not([alt=""])');
      if (text || hasLabel || hasImgAlt) return;
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
    });

    // Judge.me's star-rating summary wraps a real link ("4.89 out of 5" ->
    // its review page) inside a div given role="img". role="img" means
    // "treat this as a single flat image" — it can't legally contain any
    // focusable descendant at all, regardless of the wrapper's own
    // tabindex. Swap it for role="group", a container role that's allowed
    // to hold interactive children, while keeping the same aria-label so
    // it still announces "Average rating is X" as a whole, and also drop
    // any tabindex of its own so it isn't a redundant focus stop next to
    // the real link inside it.
    document.querySelectorAll('[role="img"]').forEach(function (el) {
      if (el.querySelector('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])')) {
        el.setAttribute('role', 'group');
        el.removeAttribute('tabindex');
      }
    });

    // Slick tags each carousel slide with role="option" to mimic a listbox,
    // but these aren't part of a real combobox/listbox with a managed
    // aria-activedescendant — the role wrongly marks the whole slide as an
    // interactive control, and it wraps several real <a> links, which trips
    // "interactive controls must not be nested." Negative tabindex on the
    // links doesn't fix that (assistive tech can still reach them via
    // browse-mode navigation) — the slide itself just shouldn't claim to be
    // interactive when only the links inside it are.
    document.querySelectorAll('[role="option"]').forEach(function (slide) {
      if (slide.querySelector('a[href], button, input, select, textarea')) {
        slide.removeAttribute('role');
      }
    });
  }

  function watchThirdPartyA11yIssues() {
    var timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(fixThirdPartyA11yIssues, 250);
    }
    fixThirdPartyA11yIssues();
    // Some third-party scripts (impression/click tracking) stamp attributes
    // like tabindex onto an *existing* element in place — e.g. via an
    // IntersectionObserver firing once an above-the-fold image scrolls into
    // view — rather than replacing the node. childList/subtree alone misses
    // that, so also watch the specific attributes our fixes care about.
    // class/style/hidden are also watched so that apps like SmartTabs,
    // which switch tab panels by toggling a class or inline style instead
    // of updating aria-hidden, still trigger a re-check.
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['tabindex', 'aria-hidden', 'role', 'aria-label', 'class', 'style', 'hidden']
    });
  }

  function init() {
    watchThirdPartyA11yIssues();
    wrapPageContent();
    injectColorMatrices();
    var overlays = buildOverlays();
    var panel = buildPanel();
    buildToggleButton(panel);

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-action="statement"]')) { e.preventDefault(); showView('statement'); return; }
      if (e.target.closest('[data-action="back"]')) { showView('options'); return; }

      var t = e.target.closest('[data-toggle], [data-step], [data-filter]');
      if (!t) return;

      if (t.dataset.toggle === 'readPage') {
        toggleReadPage(panel);
        return;
      } else if (t.dataset.toggle === 'pageStructure') {
        togglePageStructure(overlays, panel);
        return;
      } else if (t.dataset.toggle) {
        settings[t.dataset.toggle] = !settings[t.dataset.toggle];
      } else if (t.dataset.step) {
        var key = t.dataset.step, max = Number(t.dataset.max);
        settings[key] = ((settings[key] || 0) + 1) % (max + 1);
      } else if (t.dataset.filter) {
        settings.colorFilter = settings.colorFilter === t.dataset.filter ? 'none' : t.dataset.filter;
      }

      save();
      applyAll();
      syncTileStates(panel);
    });

    document.getElementById('a11y-reset').addEventListener('click', function () {
      if (speaking) { window.speechSynthesis.cancel(); speaking = false; }
      settings = Object.assign({}, defaults);
      save();
      applyAll();
      syncTileStates(panel);
      overlays.structurePanel.hidden = true;
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlays.structurePanel.hidden) {
        overlays.structurePanel.hidden = true;
        syncStructureTile(panel, false);
      }
    });

    applyAll();
    syncTileStates(panel);
  }

  function safeInit() {
    try {
      init();
    } catch (e) {
      console.error('Accessibility widget failed to initialize:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
})();
